import * as React from 'react';
import { Redirect, RedirectProps, Route, RouteProps } from 'react-router';

interface IProps extends Partial<RouteProps>, Partial<RedirectProps> {
    to: string;
    redirectTo: string;
    isAuthenticated: boolean;
    Component: React.ComponentType<any>;
    path?: string;
}

export const PrivateRoute: React.SFC<IProps> = ({ to, redirectTo, isAuthenticated, Component, exact }) => (
    <Route exact={exact} path={to} render={props => (isAuthenticated ? <Component {...props} /> : <Redirect to={redirectTo} />)} />
);



// WEBPACK FOOTER //
// ./src/_controllers/PrivateRoute.tsx